// extracted by mini-css-extract-plugin
export default {"main":"BuildingData_main__9c0PN","video":"BuildingData_video__NHZzg"};